function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export var TYPOGRAPHY_VARIANT = /*#__PURE__*/function (TYPOGRAPHY_VARIANT) {
  TYPOGRAPHY_VARIANT["DISPLAY"] = "display";
  TYPOGRAPHY_VARIANT["DISPLAY2"] = "display2";
  TYPOGRAPHY_VARIANT["HEADING1"] = "heading1";
  TYPOGRAPHY_VARIANT["HEADING2"] = "heading2";
  TYPOGRAPHY_VARIANT["HEADING3BLD"] = "heading3Bld";
  TYPOGRAPHY_VARIANT["HEADING3SEMBLD"] = "heading3SemBld";
  TYPOGRAPHY_VARIANT["HEADING4BLD"] = "heading4Bld";
  TYPOGRAPHY_VARIANT["HEADING4SEMBLD"] = "heading4SemBld";
  TYPOGRAPHY_VARIANT["BODY1"] = "body1";
  TYPOGRAPHY_VARIANT["BODY2"] = "body2";
  TYPOGRAPHY_VARIANT["CAPTIONREG"] = "captionReg";
  TYPOGRAPHY_VARIANT["CAPTIONSEMBLD"] = "captionSemBld";
  TYPOGRAPHY_VARIANT["CAPTIONUC"] = "captionUc";
  TYPOGRAPHY_VARIANT["TOOLBAR"] = "toolbar";
  return TYPOGRAPHY_VARIANT;
}({});
export var FONT_WEIGHT = /*#__PURE__*/function (FONT_WEIGHT) {
  FONT_WEIGHT[FONT_WEIGHT["BOLD"] = 700] = "BOLD";
  FONT_WEIGHT[FONT_WEIGHT["SEMIBOLD"] = 600] = "SEMIBOLD";
  FONT_WEIGHT[FONT_WEIGHT["REGULAR"] = 400] = "REGULAR";
  return FONT_WEIGHT;
}({});
;
export var typographyTheme = function typographyTheme(dir) {
  var _typography;
  var fontFamily = dir === 'rtl' ? "\"Open Sans\", \"NotoSansArabicUI\"" : 'Open Sans';
  return {
    typography: (_typography = {
      fontFamily: fontFamily
    }, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_typography, TYPOGRAPHY_VARIANT.DISPLAY, {
      fontSize: '34px',
      lineHeight: '52px',
      fontWeight: FONT_WEIGHT.BOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.DISPLAY2, {
      fontSize: '34px',
      lineHeight: 'auto',
      fontWeight: FONT_WEIGHT.REGULAR,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.HEADING1, {
      fontSize: '26px',
      lineHeight: '40px',
      fontWeight: FONT_WEIGHT.SEMIBOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.HEADING2, {
      fontSize: '18px',
      lineHeight: '28px',
      fontWeight: FONT_WEIGHT.SEMIBOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.HEADING3BLD, {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: FONT_WEIGHT.BOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.HEADING3SEMBLD, {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: FONT_WEIGHT.SEMIBOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.HEADING4BLD, {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FONT_WEIGHT.BOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.HEADING4SEMBLD, {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FONT_WEIGHT.SEMIBOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.BODY1, {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: FONT_WEIGHT.REGULAR,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.BODY2, {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: FONT_WEIGHT.REGULAR,
      fontFamily: fontFamily
    }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_typography, TYPOGRAPHY_VARIANT.CAPTIONREG, {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: FONT_WEIGHT.REGULAR,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.CAPTIONSEMBLD, {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: FONT_WEIGHT.SEMIBOLD,
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.CAPTIONUC, {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: FONT_WEIGHT.SEMIBOLD,
      // textTransform: 'uppercase',
      fontFamily: fontFamily
    }), TYPOGRAPHY_VARIANT.TOOLBAR, {
      fontSize: '11px',
      lineHeight: '16px',
      fontWeight: FONT_WEIGHT.SEMIBOLD,
      fontFamily: fontFamily
    }), "h1", {
      display: 'none'
    }), "h2", {
      display: 'none'
    }), "h3", {
      display: 'none'
    }), "h4", {
      display: 'none'
    }), "h5", {
      display: 'none'
    }), "h6", {
      display: 'none'
    }), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_typography, "overline", {
      display: 'none'
    }), "caption", {
      display: 'none'
    }), "subtitle1", {
      display: 'none'
    }), "subtitle2", {
      display: 'none'
    }))
  };
};